/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Modal,
  Select,
  Form,
  Space,
  Upload,
  Spin,
  Row,
  Col,
} from "antd";
import {
  AuditOutlined,
  BackwardOutlined,
  FormOutlined,
} from "@ant-design/icons";
import "../../../components/AdminComponents/contactStyles.css";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import { useParams, NavLink } from "react-router-dom";
import Axios from "../../../api/Axios";
import {
  CaAdminMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import { message } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import { useNavigate } from "react-router-dom";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import UserInfo from "../../../store/slices/UserInfo";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";

const { Option } = Select;
const handleRowClick = () => {};
const record = null;
const ContactEditCA = () => {
  const history = useNavigate();
  const { id, mainID } = useParams();
  // eslint-disable-next-line no-unused-vars
  const phoneInputRef = useRef();
  const [loading, setLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [access, setAccess] = useState(false); // "False" is the default value for access
  const [showAdditionalElements, setShowAdditionalElements] = useState(false);
  const [applications, setApplications] = useState([]);
  const [phone, setPhone] = useState("");
  const [additionalFieldsCount, setAdditionalFieldsCount] = useState(1);
  const [formData, setFormData] = useState();
  const [initialApplication, setInitialApplication] = useState([]);
  const [roles1, setRoles1] = useState([]);
  const [phoneObj, setPhoneObj] = useState(null);
  const [newRoles, setNewRoles] = useState();
  const handleAccessChange = (value) => {
    setAccess(value);
    //console.log(value);
    setShowAdditionalElements(value);
    setAdditionalFieldsCount(1);
  };
  const [selectedApplications, setSelectedApplications] = useState([]);

  // const handleAppSelection = (value, index) => {
  //   setSelectedApplications((prevSelectedApplications) => {
  //     const updatedSelectedApplications = [...prevSelectedApplications];
  //     updatedSelectedApplications[index] = value;
  //     return updatedSelectedApplications;
  //   });
  // };
  const handleAppSelection = (value, index) => {
    //console.log(value, index);
    setSelectedApplications((prevSelectedApplications) => {
      const updatedSelectedApplications = [...prevSelectedApplications];
      updatedSelectedApplications[index] = value;
      return updatedSelectedApplications;
    });
    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    const selectedApp = applications.find((app) => app.id === value);
    //console.log(applications);
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      if (selectedApp) {
        // set the roles for the selected application
        updatedRoles[index] = selectedApp.roles;
      } else {
        updatedRoles[index] = [];
      }
      return updatedRoles;
    });
  };
  const resetAppAnduser = (ele) => {
    //console.log(ele, "--------------------");
    formRef.current.setFieldsValue({ [`user_role[${ele}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${ele}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[ele] = [];
      return updatedRoles;
    });
  };

  const LoadApplications = async () => {
    //console.log(id);
    try {
      const res = await Axios.get(`/contactsapplications/${mainID}/`);
      //console.log(res.data);
      setApplications(res.data);
      //console.log(res.data);
      setNewRoles(res.data);
      //console.log(Math.min(res.data?.length || 0, 5));
      // setAdditionalFieldsCount(Math.min(res.data?.length || 0, 5));
      //console.log(additionalFieldsCount); // set maximum number of fields to 5 or the length of the data array, whichever is smaller
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadData = async () => {
    try {
      const res = await Axios.get(`/contacts/${id}/`);
      //console.log(res.data);
      setFormData(res.data);
      setInitialApplication(res.data?.applications);
      setAdditionalFieldsCount(res.data.applications?.length);
      for (let i = 0; i < res.data.applications?.length; i++) {
        formRef.current.setFieldsValue({
          [`applications[${i}]`]: res.data.applications[i].application,
        });
        formRef.current.setFieldsValue({
          [`user_role[${i}]`]: res.data.applications[i].role.name,
        });
        setRoles1((prevRoles) => {
          const updatedRoles = [...prevRoles];
          updatedRoles[i] = [res.data.applications[i].role.name];
          //console.log(res.data.applications[i].role.name);
          // updatedRoles[0] = [{ id: 2, name: "Editor", key_name: "editor" }];
          // updatedRoles[1] = [{ id: 2, name: "admin", key_name: "editor" }];
          return updatedRoles;
        });
      }
      setLoading(false);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadApplications();
    LoadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const applicationvalue = (index, values) => {
    if (values[`applications[${index}]`] === "Trak Learning") {
      return 1;
    } else if (values[`applications[${index}]`] === "DelegateHR") {
      return 3;
    } else if (values[`applications[${index}]`] === "Trak Coaching") {
      return 2;
    } else {
      return values[`applications[${index}]`];
    }
  };
  const rolevalue = (index, values) => {
    const value = values[`user_role[${index}]`];
    if (typeof value === "string") {
      return formData.applications[index].role.id;
    } else {
      return values[`user_role[${index}]`];
    }
  };

  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const accessRef = useRef(false);
  // const onFinish = async (values) => {
  //   console.log(formRef.phone_numebr);

  //   const phoneNumberWithPlus = "+" + phone;

  //   const updatedRoles = [...values.roles, ...removedRoleIds];
  //   const updatedValues = {
  //     ...values,
  //     roles: updatedRoles,
  //   };
  //   if (phone && phone.length > 4) {
  //     updatedValues.phone_number = "+" + phone;
  //   } else {
  //     updatedValues.phone_number = "";
  //   }

  //   const organizationId = parseInt(mainID);
  //   const normalizedValues = Object.fromEntries(
  //     Object.entries(updatedValues).filter(
  //       ([key, value]) => value !== null && value !== undefined
  //     )
  //   );
  //   const updatedValues2 = {
  //     ...normalizedValues,
  //     organization: organizationId,
  //     // phone_number: phoneNumberWithPlus,
  //     // applications: applications,
  //     // created_by: userInfo?.data?.id,
  //   };
  //   console.log("Form values:", updatedValues2);
  //   try {
  //     const res = await Axios.put(`/contacts/${id}/`, updatedValues2, {
  //       headers: {
  //         "X-CSRFToken": csrfToken,
  //       },
  //     });
  //     console.log(res);
  //     CreateSuccessfull();
  //   } catch (err) {
  //     if (err?.response?.data?.detail?.phone_number) {
  //       CreateFailed(`${err?.response?.data?.detail?.phone_number}`);
  //     } else if (err?.response?.data?.detail) {
  //       CreateFailed(err?.response?.data?.detail);
  //     } else {
  //       CreateFailed("Contact have not been edited");
  //     }
  //     console.log(err.response.data.detail);
  //   }
  // };
  const onFinish = async (values) => {
    //console.log(formRef.phone_numebr);

    // Ensure that values.roles is always an array
    const updatedRoles = Array.isArray(values.roles) ? values.roles : [];
    // Assuming removedRoleIds is also an array, you can keep it as is.

    const updatedValues = {
      ...values,
      roles: [...updatedRoles, ...removedRoleIds],
    };

    if (phone && phone.length > 4 && !phone.startsWith("+")) {
      updatedValues.phone_number = "+" + phone;
    } else if (phone && phone.length > 4 && phone.startsWith("+")) {
      updatedValues.phone_number = phone;
    } else {
      updatedValues.phone_number = "";
    }

    const organizationId = parseInt(mainID);
    const normalizedValues = Object.fromEntries(
      Object.entries(updatedValues).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const updatedValues2 = {
      ...normalizedValues,
      organization: organizationId,
    };

    //console.log("Form values:", updatedValues2);
    try {
      const res = await Axios.put(`/contacts/${id}/`, updatedValues2, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull();
    } catch (err) {
      if (err?.response?.data?.detail?.phone_number) {
        CreateFailed(`${err?.response?.data?.detail?.phone_number}`);
      } else if (err?.response?.data?.detail) {
        CreateFailed(err?.response?.data?.detail);
      } else {
        CreateFailed("Contact has not been edited");
      }
      //console.log(err.response.data.detail);
    }
  };
  const CreateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Contact has been edited.",
      duration: 5,
    });
    // LoadContacts();
    setTimeout(() => {
      history(`/ca-admin/organization/profile/relationships`);
    }, 5000);
  };
  const handleAccessReset = (index) => {
    // setAdditionalFieldsCount(0);
    //console.log("-------------------------------");
    //console.log(additionalFieldsCount);
    formRef.current.setFieldsValue({ access: false });
    setShowAdditionalElements(false);

    formRef.current.setFieldsValue({ [`user_role[${index}]`]: null });
    formRef.current.setFieldsValue({ [`applications[${index}]`]: null });
    setRoles1((prevRoles) => {
      const updatedRoles = [...prevRoles];
      updatedRoles[index] = [];
      return updatedRoles;
    });
  };
  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Contact has not been edited.",
      duration: 5,
    });
  };
  const formRef = useRef();
  const handleSubmit = async (values) => {
    const applications = [];
    for (let i = 0; i < additionalFieldsCount; i++) {
      const application = {
        application: values[`applications[${i}]`],
        role: values[`user_role[${i}]`],
      };
      applications.push(application);
    }
    //console.log(applications);
  };

  const handleReset = () => {
    formRef.current.resetFields();
    setShowAdditionalElements(false);
  };
  const [removedRoleIds, setRemovedRoleIds] = useState([]);
  useEffect(() => {
    //console.log(additionalFieldsCount);
    //console.log(roles1);
  }, [additionalFieldsCount, roles1]);
  useEffect(() => {
    if (!loading && formRef.current) {
      const rolesToSetIds = formData?.roles
        .filter((role) => newRoles.some((newRole) => newRole.id === role.id))
        .map((role) => role.id);

      //console.log(rolesToSetIds);
      const removedRoles = formData?.roles
        .map((role) => role.id)
        .filter((roleId) => !rolesToSetIds.includes(roleId));

      setRemovedRoleIds(removedRoles);
      formRef.current.setFieldsValue({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        status: formData.status,
        user_id: formData.user_id,
        access: formData.access,
        job_title: formData.job_title,
        phone_number:
          formData.phone_number === null || formData.phone_number === ""
            ? "+1"
            : formData.phone_number,
        roles: rolesToSetIds,
      });
      if (formData.access) {
        setShowAdditionalElements(true);
      }
      setPhone(formData.phone_number);
    }
  }, [loading, formData, newRoles]);
  const [selectedNaics, setSelectedNaics] = useState("");
  const [naicsRes, setNaicsRes] = useState();
  const handleNaicsSearch = async (value) => {
    //console.log(value);
    if (value.length >= 2) {
      const response = await Axios.get(
        `/locationlist/${UserInfo.data.organization.id}/?search=${value}`
      );
      //console.log(response);
      setNaicsRes(response.data);
    } else {
      setNaicsRes([]);
    }
  };

  const handleNaicsSelect = (value) => {
    setSelectedNaics(value);
  };

  const handleNaicsBlur = () => {
    if (!selectedNaics) {
      setSelectedNaics("");
    }
  };
  const handlePhoneNumberChange = (value, data, event, formattedValue) => {
    //console.log(data);

    setPhone(value);
  };
  return (
    <div>
      <CaSideNav props={CaAdminMenu}>
        {contextHolder}
        <SecondaryNav2 id={parseInt(id)} menuItems={SecondaryNavCaAdmin} />
        <div className="light-bar-container">
          {/* <nav> */}
          <NavLink
            to={`/ca-admin/organization/profile/relationships/edit-contact/${id}/${mainID}`}
            className={(navigationData) =>
              navigationData.isActive
                ? "link-heading-latest-active"
                : "link-heading-latest"
            }
            style={{ paddingLeft: "3rem" }}
          >
            <span>
              <AuditOutlined />
            </span>
            Edit Contact
          </NavLink>

          {/* </nav> */}
        </div>
        <Spin spinning={loading}>
          <div className="form-container-2">
            <Form
              name="complex-form"
              onFinish={onFinish}
              layout="vertical"
              ref={formRef}
              initialValues={formData}
              labelCol={{
                span: 25,
              }}
              wrapperCol={{
                span: 80,
              }}
              style={{
                width: "100%",
                marginBottom: "150px",
              }}
            >
              <div className="group1">
                <div className="form-heading">
                  {capitalizeWords("EDIT CONTACT INFO")}
                </div>
                <div className="antd-test-client" style={{ marginTop: "2rem" }}>
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">First Name</p>}
                      >
                        <Form.Item
                          name="first_name"
                          noStyle
                          rules={[
                            { required: true, message: "Username is required" },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder={"Enter user name"}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Last Name</p>}
                      >
                        <Form.Item name="last_name">
                          <Input
                            placeholder="Enter last name"
                            className="my-form-input-antd-test"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={7} xl={7}>
                      <Form.Item
                        label={<p className="my-form-lables">Email</p>}
                      >
                        <Form.Item
                          name="email"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Enter a valid email",
                              type: "email",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter Email"
                            className="my-form-input-antd-test"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Position</p>}
                      >
                        <Form.Item
                          name="job_title"
                          rules={[
                            {
                              required: access, // Make it required when access is true
                              message: "Please enter a position", // Error message if not filled
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter Position"
                            className="my-form-input-antd-test"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                <div className="antd-test-client">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <div
                      style={{ display: "inline-block", marginLeft: "1rem" }}
                    >
                      <Form.Item
                        label={<p className="my-form-lables">Phone No.</p>}
                      >
                        <Space>
                          <Form.Item noStyle name="phone_number">
                            <PhoneInput
                              // className="my-form-input"
                              ref={phoneInputRef}
                              placeholder="Enter your Phone No."
                              country="us"
                              value={phone}
                              // style={{ width: "27rem" }}
                              onChange={handlePhoneNumberChange}
                              onBlur={() => {
                                try {
                                  const phoneObj =
                                    parsePhoneNumberFromString(phone);
                                  setPhoneObj(phoneObj);
                                } catch (e) {
                                  setPhoneObj(null);
                                }
                              }}
                            />
                          </Form.Item>
                        </Space>
                      </Form.Item>
                    </div>

                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Status</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="status" noStyle initialValue={true}>
                            <Select
                              placeholder="Select Status"
                              className="my-form-input-antd-test"
                            >
                              <Option value={true}>Active</Option>
                              <Option value={false}>Unactive</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">System Access</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="access" noStyle initialValue={false}>
                            <Select
                              placeholder="Select Access"
                              className="my-form-input-antd-test"
                              // value={accessRef.current}
                              onChange={handleAccessChange}
                            >
                              <Option value={true}>Yes</Option>
                              <Option value={false}>No</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">User ID</p>}
                      >
                        <Form.Item
                          name="user_id"
                          noStyle
                          initialValue={null}
                          rules={[
                            {
                              max: 11,
                              message: "max length 11 characters",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter user ID"
                            disabled={!showAdditionalElements}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                {/* {showAdditionalElements && (
              <div className="group-1-box" style={{ marginTop: "2rem" }}>
                <div style={{ display: "inline-block" }}>
                  <Form.Item
                    label={<p className="my-form-lables">Applications</p>}
                  >
                    <Input.Group compact>
                      <Form.Item name="applications" noStyle initialValue={[]}>
                        <Select
                          placeholder="Select Type"
                          className="my-form-input"
                          style={{ width: "26rem" }}

                        >
                          {applications?.map((app) => (
                            <Option key={app.id} value={app.id}>
                              {app.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
                <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                  <Form.Item
                    label={<p className="my-form-lables">User Role</p>}
                  >
                    <Input.Group compact>
                      <Form.Item name="user_role" noStyle>
                        <Input
                          placeholder="Enter user role"
                          className="my-form-input"
                          style={{ width: "26rem" }}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </div>
              </div>
            )} */}
                {showAdditionalElements && (
                  // <div className="group-1-box" style={{ marginTop: "2rem" }}>
                  <div
                    className="antd-test-client"
                    style={{ marginTop: "2rem" }}
                  >
                    <Row gutter={20} style={{ marginLeft: "2rem" }}>
                      <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                        <Form.Item
                          label={<p className="my-form-lables">Roles</p>}
                        >
                          <Input.Group compact>
                            <Form.Item name="roles" noStyle initialValue={[]}>
                              <Select
                                placeholder="Select Roles"
                                className="my-form-input-antd-test"
                                mode="multiple"
                                // onChange={handleRoleSelection}
                              >
                                {newRoles?.map((role) => (
                                  <Option key={role.id} value={role.id}>
                                    {role.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                        <Form.Item
                          label={<p className="my-form-lables">Location</p>}
                        >
                          <Form.Item name="Location" noStyle>
                            <Select
                              showSearch
                              placeholder="Enter Location"
                              filterOption={false}
                              className="my-form-input-antd-test"
                              onSearch={handleNaicsSearch}
                              onSelect={handleNaicsSelect}
                              onBlur={handleNaicsBlur}
                              value={selectedNaics}
                            >
                              {naicsRes?.map((naics) => (
                                <Option key={naics.id} value={naics.id}>
                                  {`${naics.name}`}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                )}
                {/* {showAdditionalElements && (
                  <div>
                    {Array.from(Array(additionalFieldsCount)).map(
                      (_, index) => {
                        const filteredApplications = applications.filter(
                          (app) =>
                            !selectedApplications.includes(app.id) ||
                            selectedApplications[index] === app.id
                        );
                        //console.log(
                          "filteredApplications:",
                          filteredApplications
                        );
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "2rem",
                            }}
                          >
                            <div style={{ marginLeft: "3rem" }}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">Applications</p>
                                }
                              >
                                <Input.Group compact>
                                  <Form.Item
                                    name={`applications[${index}]`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Application is required",
                                      },
                                    ]}
                                    noStyle
                                    initialValue={
                                      selectedApplications[index] || undefined
                                    }
                                  >
                                    <Select
                                      placeholder="Select Type"
                                      className="my-form-input"
                                      style={{ width: "26rem" }}
                                      onChange={(value) => {
                                        setSelectedApplications((prev) => {
                                          const updated = [...prev];
                                          updated[index] = value;
                                          return updated;
                                        });
                                        handleAppSelection(value, index); // call handleAppSelection with the selected value
                                      }}
                                    >
                                      {filteredApplications.map((app) => (
                                        <Option key={app.id} value={app.id}>
                                          {app.name}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Input.Group>
                              </Form.Item>
                            </div>
                            <div style={{ marginLeft: "2rem" }}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">User Role</p>
                                }
                              >
                                <Input.Group compact>
                                  <Form.Item
                                    name={`user_role[${index}]`}
                                    noStyle
                                    rules={[
                                      {
                                        required: true,
                                        message: "Role is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      placeholder="Select Type"
                                      className="my-form-input"
                                      style={{ width: "26rem" }}
                                    >
                                      {Array.isArray(roles1[index]) &&
                                        roles1[index].map((app) => (
                                          <Option key={app.id} value={app.id}>
                                            {app.name}
                                          </Option>
                                        ))}
                                    </Select>
                                  </Form.Item>
                                </Input.Group>
                              </Form.Item>
                            </div>

                            <div style={{ flex: 1, marginLeft: "2rem" }}>
                              {additionalFieldsCount === index + 1 && (
                                <Button
                                  onClick={() => {
                                    // setAdditionalFieldsCount(additionalFieldsCount - 1)
                                    setAdditionalFieldsCount(() => {
                                      if (additionalFieldsCount === 1) {
                                        handleAccessReset(index);
                                      } else {
                                        //console.log("dsssssssssss");
                                        resetAppAnduser(index);
                                        return additionalFieldsCount - 1;
                                      }
                                    });

                                    setSelectedApplications((prev) => {
                                      const copy = [...prev];
                                      copy.splice(index, 1); // remove the element at index
                                      return copy;
                                    });
                                  }}
                                  style={{ marginRight: "1rem" }}
                                >
                                  Remove
                                </Button>
                              )}
                              {additionalFieldsCount < applications?.length && (
                                <Button
                                  onClick={() => {
                                    setAdditionalFieldsCount((prevCount) => {
                                      //console.log(prevCount + 1); // log the updated value of additionalFieldsCount
                                      return prevCount + 1; // return the new value of additionalFieldsCount
                                    });
                                    // setSelectedApplications([]);
                                  }}
                                >
                                  Add
                                </Button>
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                )} */}
                {/* {showAdditionalElements && (
                  <div style={{ display: "inline-block", marginLeft: "2rem" }}>
                    <Form.Item
                      label={<p className="my-form-lables">Location</p>}
                    >
                      <Space>
                        <Form.Item name="Location" noStyle>
                          <Select
                            showSearch
                            placeholder="Enter Location"
                            filterOption={false}
                            className="my-form-input"
                            style={{ width: "26rem" }}
                            onSearch={handleNaicsSearch}
                            onSelect={handleNaicsSelect}
                            onBlur={handleNaicsBlur}
                            value={selectedNaics}
                          >
                            {naicsRes?.map((naics) => (
                              <Option key={naics.id} value={naics.id}>
                                {`${naics.name}`}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Space>
                    </Form.Item>
                  </div>
                )} */}
              </div>
              <div style={{ display: "inline-block", marginLeft: "5rem" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history(`/ca-admin/organization/profile/relationships`);
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              {/* <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </div> */}
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    // className="my-form-input-end"
                    style={{
                      background: "#f58029",
                      // fontWeight: "600",
                    }}
                    className="save-update-btn"
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Spin>
      </CaSideNav>
    </div>
  );
};

export default ContactEditCA;
